import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'
import Line from '../Line'
import Text from '../Text'

const SectionDivider = (props) => {
  const { boxProps, children, marginTop } = props

  return (
    <Box alignItems="center" marginTop={marginTop} {...boxProps}>
      <Line />

      <Text fontSize="xsmall" letterSpacing="1px" marginX="large" style={{ textTransform: 'uppercase', flexShrink: 0 }}>
        {children}
      </Text>

      <Line />
    </Box>
  )
}

SectionDivider.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  marginTop: PropTypes.string,
}

export default SectionDivider
